<app-application-menu></app-application-menu>

<div class="my-3" style="min-height: 600px">

  <div class="container">
    <app-messages timeout=10000></app-messages>
  </div>

  <router-outlet></router-outlet>

</div>

<app-application-footer></app-application-footer>